import React from 'react';

const ReadonlyOverlay = ({ children, readonly }) => {
  const isReadonly = readonly === true || readonly === "true";
  return (
    <div className="readonly-container w-100" data-readonly={isReadonly}>
      {children}
      {isReadonly && <div className="readonly-overlay"></div>}
    </div>
  );
};

export default ReadonlyOverlay;
